import router from './router';
import './language.js';
import regex from '@/commons/regex.js';
import common from '@/commons/common.js';
window.tdExtend = {
    regex: regex,
    common: common
};
window.app.modRouter.push(router);
let menuData = sessionStorage.getItem('menuData');
if (menuData) {
    router.mergeRoutes(JSON.parse(menuData), window.vue.$router.options.routes[1].children);
    window.vue.$router.addRoutes(window.vue.$router.options.routes);
}
